/* eslint-disable @typescript-eslint/no-wrapper-object-types*/

export abstract class SQLWhereClauseToken {
  static readonly CONDITIONAL_COMPARATOR_IS_EQUAL = ' = ';
  static readonly CONDITIONAL_COMPARATOR_LESS_THAN = ' < ';
  static readonly CONDITIONAL_COMPARATOR_GREATER_THAN = ' > ';
  static readonly CONDITIONAL_COMPARATOR_LESS_EQ_THAN = ' <= ';
  static readonly CONDITIONAL_COMPARATOR_GREATER_EQ_THAN = ' >= ';
  static readonly CONDITIONAL_COMPARATOR_STARTS_LIKE = " like '%@' ";
  static readonly CONDITIONAL_COMPARATOR_ENDS_LIKE = " like '@%' ";
  static readonly CONDITIONAL_COMPARATOR_CONTAINS_LIKE = " like '%@%' ";
  static readonly CONDITIONAL_COMPARATOR_IN = ' in (@) ';
  static readonly CONDITIONAL_COMPARATOR_BETWEEN = ' between @ and @ ';

  readonly value: Object;
  readonly valueComparator: string;
  readonly useNotCondition: boolean = false;
  readonly ignoreCase: boolean = false;

  protected constructor(
    value: Object,
    valueComparator: string = SQLWhereClauseToken.CONDITIONAL_COMPARATOR_IS_EQUAL,
    useNotCondition = false,
    ignoreCase = false,
  ) {
    this.value = value;
    this.valueComparator = valueComparator;
    this.useNotCondition = useNotCondition;
    this.ignoreCase = ignoreCase;
  }
}

export class SQLWhereBetween extends SQLWhereClauseToken {
  constructor(minValue: Object, maxValue: Object) {
    super([minValue, maxValue], SQLWhereClauseToken.CONDITIONAL_COMPARATOR_BETWEEN);
  }
}

export class SQLWhereContainsLike extends SQLWhereClauseToken {
  constructor(value: Object, useNotCondition = false) {
    super(value, SQLWhereClauseToken.CONDITIONAL_COMPARATOR_CONTAINS_LIKE, useNotCondition);
  }
}

export class SQLWhereStartsLike extends SQLWhereClauseToken {
  constructor(value: Object, useNotCondition = false) {
    super(value, SQLWhereClauseToken.CONDITIONAL_COMPARATOR_STARTS_LIKE, useNotCondition);
  }
}

export class SQLWhereEndsLike extends SQLWhereClauseToken {
  constructor(value: any, useNotCondition = false) {
    super(value, SQLWhereClauseToken.CONDITIONAL_COMPARATOR_ENDS_LIKE, useNotCondition);
  }
}

export class SQLWhereIn extends SQLWhereClauseToken {
  constructor(value: Object[], useNotCondition = false, ignoreCase = false) {
    super(value, SQLWhereClauseToken.CONDITIONAL_COMPARATOR_IN, useNotCondition, ignoreCase);
  }
}

export class SQLWhereEquals extends SQLWhereClauseToken {
  constructor(value: Object, useNotCondition = false) {
    super(value, SQLWhereClauseToken.CONDITIONAL_COMPARATOR_IS_EQUAL, useNotCondition);
  }
}

export class SQLWhereLessThan extends SQLWhereClauseToken {
  constructor(value: Object, useNotCondition = false) {
    super(value, SQLWhereClauseToken.CONDITIONAL_COMPARATOR_LESS_THAN, useNotCondition);
  }
}

export class SQLWhereLessEqThan extends SQLWhereClauseToken {
  constructor(value: Object, useNotCondition = false) {
    super(value, SQLWhereClauseToken.CONDITIONAL_COMPARATOR_LESS_EQ_THAN, useNotCondition);
  }
}

export class SQLWhereGreaterThan extends SQLWhereClauseToken {
  constructor(value: Object, useNotCondition = false) {
    super(value, SQLWhereClauseToken.CONDITIONAL_COMPARATOR_GREATER_THAN, useNotCondition);
  }
}

export class SQLWhereGreaterEqThan extends SQLWhereClauseToken {
  constructor(value: Object, useNotCondition = false) {
    super(value, SQLWhereClauseToken.CONDITIONAL_COMPARATOR_GREATER_EQ_THAN, useNotCondition);
  }
}

export interface SearchOfferDetails {
  gpId?: SQLWhereClauseToken;
  anlageId?: SQLWhereClauseToken;
  product?: SQLWhereClauseToken;
  tariff?: SQLWhereClauseToken;
  offerType?: SQLWhereClauseToken;
  offerOrigin?: SQLWhereClauseToken;
  email?: SQLWhereClauseToken;
  status?: SQLWhereClauseToken;
  createdAt?: SQLWhereBetween;
  endsAt?: SQLWhereBetween;
  orderByFields?: string[];
  sortOrder?: string;
}
